import { render, staticRenderFns } from "./ProfileTalentEndorsementsListItem.vue?vue&type=template&id=487a0b98"
import script from "./ProfileTalentEndorsementsListItem.vue?vue&type=script&lang=js"
export * from "./ProfileTalentEndorsementsListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports